export const PAGES = {
    'howToUse': 'User Manual',
    'technologies': 'Technologies/Langages',
}